/**
 * Hook to fetch workspace knowledge sources
 */

import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { KnowledgeSource, knowledgeApi } from "../api";

export const useKnowledgeSourcesWorkspace = (): UseQueryResult<KnowledgeSource[], Error> => {
  return useQuery<KnowledgeSource[], Error>({
    queryKey: ["ai-studio", "knowledge"],
    queryFn: () => knowledgeApi.list(),
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 2
  });
};
